import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { RoutingUrl } from '../constant/route-const';

import { UserService } from '@workflow/ecp-shared/service/user/user.service';
/**
 *
 * AuthenticateGuard Service
 * @export
 * @ class AuthenticateGuard
 */
@Injectable()
export class AuthenticateGuard {
  constructor(private readonly router: Router, private readonly userService: UserService) {}

  /**
   * Class representing the auth service.
   *
   * param {ActivatedRouteSnapshot} route
   * param {RouterStateSnapshot} state
   * returns {boolean}
   * memberof AuthenticateGuard
   */
  public canActivate(): boolean {
    const userToken = this.userService.user ? this.userService.user.token : undefined;
    if (!userToken) {
      this.router.navigate(['/']);
      return false;
    } else if (userToken && this.userService.isConsumer) {
      this.router.navigate([RoutingUrl.Dashboard]);
      return false;
    }

    return true;
  }
}
